import { PermissionFlags } from 'src/app/enums/permissionFlags.enum';

export enum GridPermissions {
    Read = 1 << 0,
    Create = 1 << 1,
    Update = 1 << 2,
    Delete = 1 << 3,
}

export const gridToPermissionFlags: Record<GridPermissions, PermissionFlags> = {
    [GridPermissions.Read]: PermissionFlags.ReadMy | PermissionFlags.ReadHierarchy,
    [GridPermissions.Create]: PermissionFlags.CreateMy | PermissionFlags.CreateHierarchy,
    [GridPermissions.Update]: PermissionFlags.UpdateMy | PermissionFlags.UpdateHierarchy,
    [GridPermissions.Delete]: PermissionFlags.DeleteMy | PermissionFlags.DeleteHierarchy,
};